import * as React from 'react';
import Checkbox from '@material-ui/core/Checkbox';

const CustomCheckbox = (props) => {
    return <Checkbox {...props} />;
};

export { CustomCheckbox as Checkbox };
